export default "/images/vendor/flag-icon-css/flags/1x1/hr.svg?f3f2e25c45a219c68654040bb674a6c4";